import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

export default function CurrencySelector() {
  return (
    <Select defaultValue="USDC">
      <Option value="USDC">USDC</Option>
      {/* <Option value="WETH">WETH</Option> */}
    </Select>
  );
}